import React, { Suspense, lazy } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { GeoProvider } from './context/GeoContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import AuthModal from './components/AuthModal';
import HomePage from './pages/HomePage';
import CartLoader from './components/CartLoader';
import AssistantChat from './components/AssistantChat';
import AlertsDialog from './components/AlertsDialog';
import CookieBanner from './components/CookieBanner';
import DemoNotice from './components/DemoNotice';
import { ShoppingListProvider } from './context/ShoppingListContext';

const AdminPage = lazy(() => import('./pages/AdminPage'));
const AdvertiserPage = lazy(() => import('./pages/AdvertiserPage'));
const StoresPage = lazy(() => import('./pages/StoresPage'));
const StorePage = lazy(() => import('./pages/StorePage'));
const CatalogPage = lazy(() => import('./pages/CatalogPage'));
const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage'));
const ShoppingListPage = lazy(() => import('./pages/ShoppingListPage'));
const LivePage = lazy(() => import('./pages/LivePage'));
const LiveIndexPage = lazy(() => import('./pages/LiveIndexPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));

const ThemedToaster = () => <Toaster theme={useTheme().theme} position="bottom-right" richColors />;
const PageFallback = () => <div className="min-h-screen bg-black flex items-center justify-center" data-testid="page-loading"><CartLoader /></div>;

const PageRoutes = () => {
  const { pathname } = useLocation();
  return (
    <div key={pathname.split('/').slice(0, 2).join('/')} className="page-enter" data-testid="page-container">
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/annonceur" element={<AdvertiserPage />} />
          <Route path="/magasins" element={<StoresPage />} />
          <Route path="/magasins/:slug" element={<StorePage />} />
          <Route path="/catalogue/:id" element={<CatalogPage />} />
          <Route path="/liste" element={<ShoppingListPage />} />
          <Route path="/live" element={<LiveIndexPage />} />
          <Route path="/live/:slug" element={<LivePage />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Suspense>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
      <ShoppingListProvider>
      <GeoProvider>
        <BrowserRouter>
          <DemoNotice />
          <PageRoutes />
          <AuthModal />
          <AlertsDialog />
          <AssistantChat />
          <CookieBanner />
          <ThemedToaster />
        </BrowserRouter>
      </GeoProvider>
      </ShoppingListProvider>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
